import './theme/scripts/comments'
import './theme/scripts/rating'
